import { Component, OnInit, NgZone  } from '@angular/core';
import { Router } from '@angular/router';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { from } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ConvertDatetimePipe } from "../../../app/convert-datetime.pipe";
@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss'],
  standalone: true,
  imports: [CommonModule,MatIconModule, MatButtonModule]

})

export class AdminDashboardComponent implements OnInit {
  [key: string]: any;
  private CountUrl = BaseUrlConstantsService.DASHBOARD_COUNT;
  private deviceCountUrl = BaseUrlConstantsService.DASHBOARD_DEVICE_COUNT;
  private kurtosisFilesURL = BaseUrlConstantsService.KURTOSIS_FILES_COUNT;
  private IOTBOTFilesURL = BaseUrlConstantsService.IOT_BOT_FILES_COUNT;
  private deviceSendingMostFilesURL = BaseUrlConstantsService.DEVICES_SENDING_MOST_FILES;
  private numberOfAlertsGeneratedURL = BaseUrlConstantsService.NUMBER_OF_ALERTS_GENERATED;
  private deviceInventoryCountURL = BaseUrlConstantsService.DEVICE_INVENTORY_COUNT;
  public devicesValue: any = 0;
  public regDevicesValue: any = 0;
  public clientsValue: any = 0;
  public tempClientsValue: any = 0;
  public tempRegValue: any = 0;
  public tempDeviceValue: any = 0;
  public loading: any;
  public summaryUnprocessedTodayCount: any = 0;
  public summaryProcessedTodayCount: any = 0;
  public summaryUnprocessedYesterdayCount: any = 0;
  public summaryProcessedYesterdayCount: any = 0;
  public fullUnprocessedTodayCount: any = 0;
  public fullProcessedTodayCount: any = 0;
  public fullUnprocessedYesterdayCount: any = 0;
  public fullProcessedYesterdayCount: any = 0;
  public kurtosisUnprocessedTodayCount: any = 0;
  public kurtosisUnprocessedYesterdayCount: any = 0;
  public kurtosisProcessedTodayCount: any = 0;
  public kurtosisProcessedYesterdayCount: any = 0;
  public numberOfAlertsGeneratedCount: any = 0;
  public tempsummaryUnprocessedTodayCount: any = 0;
  public tempsummaryProcessedTodayCount: any = 0;
  public tempsummaryUnprocessedYesterdayCount: any = 0;
  public tempsummaryProcessedYesterdayCount: any = 0;
  public tempfullUnprocessedTodayCount: any = 0;
  public tempfullProcessedTodayCount: any = 0;
  public tempfullUnprocessedYesterdayCount: any = 0;
  public tempfullProcessedYesterdayCount: any = 0;
  public tempkurtosisUnprocessedTodayCount: any = 0;
  public tempkurtosisUnprocessedYesterdayCount: any = 0;
  public tempkurtosisProcessedTodayCount: any = 0;
  public tempkurtosisProcessedYesterdayCount: any = 0;
  public tempnumberOfAlertsGeneratedCount: any = 0;
  public summaryFilesPerHourThreshold: any = 10;
  public fullRefreshFilesPerHourThreshold: any = 1;
  public devicesSendingMostFiles: any;
  public deviceSendingMostFilesLength: any = 0;
  public pollingInterval: any;
  public sortedDevices: any = [];
  public sortDirection: 'asc' | 'desc' = 'desc';
  public tempDeviceUnusedFree: any = 0;
  public tempDeviceAssociatedFree: any = 0;
  public tempDeviceAssociatedUsed: any = 0;
  public deviceUnusedFree: any = 0;
  public deviceAssociatedFree: any = 0;
  public deviceAssociatedUsed: any = 0;
  public today: Date = new Date;
  public isRefreshing: boolean = false;
  public p
  constructor(public router: Router, private changeService: ChangeUsersService, private service: BackendApiService, private zone: NgZone) { this.utcTime();}
  ngOnInit() {
    this.getCount();
    this.startPolling();
    this.getKurtosisFilesCount();
    this.getIOTBOTFilesCount();
    this.getDevicesSendingMostFiles();
    this.getNumberOfAlertsGenerated();
    this.getDeviceInventoryUnusedFreeCount();
    this.getDeviceInventoryAssociatedFreeCount();
    this.getDeviceInventoryAssociatedUsedCount();
  }
utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }
  startPolling() {
    this.pollingInterval = setInterval(() => {
      this.allTheThings();
    }, 120000);
  }

  startPolling2() {
    this.pollingInterval = setInterval(() => {
      this.getCount();
      this.getDeviceInventoryUnusedFreeCount();
      this.getDeviceInventoryAssociatedFreeCount();
      this.getDeviceInventoryAssociatedUsedCount();
      this.getNumberOfAlertsGenerated();
    }, 600000);
  }

  allTheThings() {
    this.getKurtosisFilesCount();
    this.getIOTBOTFilesCount();
    this.getDevicesSendingMostFiles();

  }
  refreshDashboardData() {
    this.isRefreshing = true;

    // You can use forkJoin if they are Observables
    Promise.all([
      this.getCount(),
      this.getDeviceInventoryUnusedFreeCount(),
      this.getDeviceInventoryAssociatedFreeCount(),
      this.getDeviceInventoryAssociatedUsedCount(),
      this.getNumberOfAlertsGenerated(),
      this.allTheThings()
    ]).finally(() => {
      this.isRefreshing = false;
    });
  }
  clearPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
  }

  ngOnDestroy() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  }


  showNewDevices() {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: 'fromDashboard'
      }
    };
    this.router.navigate(['/devices'], navigationExtras);
  }

  async getCount() {
    let token = localStorage.getItem('token');
    this.changeService.loader(true);
    this.service.getData(this.CountUrl).then(res => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.clientsValue = JSON.parse(JSON.stringify(res)).data.clients_count;
        this.devicesValue = JSON.parse(JSON.stringify(res)).data.device_count;
        this.regDevicesValue = JSON.parse(JSON.stringify(res)).data.new_device_count;
        this.animateCount('tempClientsValue', this.clientsValue, this.tempClientsValue, 500);
        this.animateCount('tempDeviceValue', this.devicesValue, this.tempDeviceValue, 500);
        this.animateCount('tempRegValue', this.regDevicesValue, this.tempRegValue, 500);
      } else {
        this.service.showError('Something went wrong.');
      }
    });
  }


  async getDeviceCount() {
    this.changeService.loader(true);
    this.service.getData(this.CountUrl).then(res => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.devicesValue = JSON.parse(JSON.stringify(res)).data.body.devices;
        this.regDevicesValue = JSON.parse(JSON.stringify(res)).data.body.registeredDevices;
      } else {
        this.service.showError('Something went wrong.');
      }
    });
  }

  goToClientList() {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pid: true
      }
    };
    this.router.navigate(['/clients'], navigationExtras);
  }

  goToDeviceList() {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pid: true
      }
    };
    this.router.navigate(['view-device-type'], navigationExtras);
  }

  async getIOTBOTFilesCount() {
      this.loading = { ...this.loading,
        summaryUnprocessedToday: true,
        summaryProcessedToday: true,
        summaryUnprocessedYesterday: true,
        summaryProcessedYesterday: true,
        fullUnprocessedToday: true,
        fullProcessedToday: true,
        fullUnprocessedYesterday: true,
        fullProcessedYesterday: true,
      };

      const endpoints = [
        { key: "summaryUnprocessedToday", url: `${this.IOTBOTFilesURL}/0/0/0` },
        { key: "summaryProcessedToday", url: `${this.IOTBOTFilesURL}/0/1/0` },
        { key: "summaryUnprocessedYesterday", url: `${this.IOTBOTFilesURL}/0/0/1` },
        { key: "summaryProcessedYesterday", url: `${this.IOTBOTFilesURL}/0/1/1` },
        { key: "fullUnprocessedToday", url: `${this.IOTBOTFilesURL}/1/0/0` },
        { key: "fullProcessedToday", url: `${this.IOTBOTFilesURL}/1/1/0` },
        { key: "fullUnprocessedYesterday", url: `${this.IOTBOTFilesURL}/1/0/1` },
        { key: "fullProcessedYesterday", url: `${this.IOTBOTFilesURL}/1/1/1` },
      ];

      await Promise.all(
        endpoints.map(async ({ key, url }) => {
          try {
            const response = await this.service.getDataV2(url);
            this[key + "Count"] = (response as any)?.success ? parseInt((response as any).count, 10) : 0;
            this.animateCount('temp' + key + 'Count', this[key + "Count"], this['temp' + key + 'Count'], 500);
          } catch (error) {
            console.error(`Error fetching data for ${key}:`, error);
          } finally {
            this.loading[key] = false;
          }
        })
      );

  }


  async getKurtosisFilesCount() {
      this.loading = { ...this.loading,
        kurtosisUnprocessedToday: true,
        kurtosisUnprocessedYesterday: true,
        kurtosisProcessedToday: true,
        kurtosisProcessedYesterday: true,
      };

      const endpoints = [
        { key: "kurtosisUnprocessedToday", url: `${this.kurtosisFilesURL}/0/0` },
        { key: "kurtosisUnprocessedYesterday", url: `${this.kurtosisFilesURL}/0/1` },
        { key: "kurtosisProcessedToday", url: `${this.kurtosisFilesURL}/1/0` },
        { key: "kurtosisProcessedYesterday", url: `${this.kurtosisFilesURL}/1/1` },
      ];

      await Promise.all(
        endpoints.map(async ({ key, url }) => {
          try {
            const response = await this.service.getDataV2(url);
            this[key + "Count"] = (response as any)?.success ? parseInt((response as any).count, 10) || 0 : 0;
            this.animateCount('temp' + key + 'Count', this[key + "Count"], this['temp' + key + 'Count'], 500);
          } catch (error) {
            console.error(`Error fetching data for ${key}:`, error);
          } finally {
            this.loading[key] = false;
          }
        })
      );

  }

  async getDevicesSendingMostFiles () {
    try {
      const response = await this.service.getDataV2(this.deviceSendingMostFilesURL + `${this.summaryFilesPerHourThreshold}/${this.fullRefreshFilesPerHourThreshold}`);
      if((response as any).success) {
        this.devicesSendingMostFiles = (response as any).data;
        this.deviceSendingMostFilesLength = this.devicesSendingMostFiles.length;
        this.sortDevices();
      }
    }
    catch (error) {
      console.error(`Error fetching data for DevicesSendingMostFiles:`, error);
    }
    finally {
    }
  }

  async getDeviceInventoryUnusedFreeCount () {
    try {
      const response = await this.service.getDataV2(this.deviceInventoryCountURL + `0`);
      if((response as any).success) {
        this.tempDeviceUnusedFree = (response as any).count;
        this.animateCount('tempDeviceUnusedFree', this.tempDeviceUnusedFree, this.deviceUnusedFree, 500);
      }
    }
    catch (error) {
      console.error(`Error fetching data for count:`, error);
    }
    finally {
    }
  }

  async getDeviceInventoryAssociatedFreeCount () {
    try {
      const response = await this.service.getDataV2(this.deviceInventoryCountURL + `1`);
      if((response as any).success) {
        this.tempDeviceAssociatedFree = (response as any).count;
        this.animateCount('tempDeviceAssociatedFree', this.tempDeviceAssociatedFree, this.deviceAssociatedFree, 500);
      }
    }
    catch (error) {
      console.error(`Error fetching data for count:`, error);
    }
    finally {
    }
  }

  async getDeviceInventoryAssociatedUsedCount () {
    try {
      const response = await this.service.getDataV2(this.deviceInventoryCountURL + `2`);
      if((response as any).success) {
        this.tempDeviceAssociatedUsed = (response as any).count;
        this.animateCount('tempDeviceAssociatedUsed', this.tempDeviceAssociatedUsed, this.deviceAssociatedUsed, 500);
      }
    }
    catch (error) {
      console.error(`Error fetching data for count:`, error);
    }
    finally {
    }
  }

  async getNumberOfAlertsGenerated () {
    try {
      const response = await this.service.getDataV2(this.numberOfAlertsGeneratedURL);
      if((response as any).code === 200) this.numberOfAlertsGeneratedCount = parseInt((response as any).data.body.alerts.total_error_count);
      this.animateCount('tempnumberOfAlertsGeneratedCount', this.numberOfAlertsGeneratedCount, this.tempnumberOfAlertsGeneratedCount, 500);
    }
    catch (error) {
      console.error(`Error fetching data for getNumberOfAlertsGenerated:`, error);
    }
    finally {
    }
  }

  animateCount(property: string, targetValue: number, currentValue: number, duration: number): void {
    // let currentValue = 0;
    const startTime = performance.now(); // Get start time for accurate duration
    const difference = targetValue - currentValue;

    this.zone.runOutsideAngular(() => {
        const animate = (currentTime: number) => {
            const elapsedTime = currentTime - startTime;

            if (elapsedTime >= duration) {
                this.zone.run(() => {
                    (this as any)[property] = targetValue;
                });
                return;
            }

            const progress = elapsedTime / duration;
            const newValue = Math.round(currentValue + difference * progress);

            this.zone.run(() => {
                (this as any)[property] = newValue;
            });

            requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
    });
  }

  sortDevices() {
    if(!this.devicesSendingMostFiles) return;
    this.sortedDevices = [...this.devicesSendingMostFiles].sort((a: any, b: any) => {
      const sumA = a.summaryFilesCount + a.fullRefreshFilesCount;
      const sumB = b.summaryFilesCount + b.fullRefreshFilesCount;
      return this.sortDirection === 'asc' ? sumA - sumB : sumB - sumA;
    })
  }

  toggleSortDirection() {
    this.sortDirection = this.sortDirection === 'desc' ? 'asc' : 'desc';
    this.sortDevices();
  }

}
